import type { GetPlacesOfSafetyResponse } from "@thalamos/vision-common";
import { config } from "@thalamos/vision-common";

import { useApiAxios } from "../axios/api.js";

// Re-export (not `const api = placeOfSafetyRequests`) so the emitted type is
// referenced via the package rather than re-inferred through axios's pnpm path,
// which is non-portable and trips TS2883.
export { placeOfSafetyRequests as api } from "@thalamos/vision-common";

export const apiHooks = () => {
  return {
    placeOfSafety: {
      getAll: function useGetAll() {
        return useApiAxios<GetPlacesOfSafetyResponse>(
          config.placeOfSafety.getAll(),
        );
      },
    },
  };
};
